import React from "react";
import PropTypes from "prop-types";

export function Steps({ currentStep, children }) {
  const stepsArray = React.Children.toArray(children);

  return (
    <>
      {stepsArray.map((child, index) => {
        if (!React.isValidElement(child)) return null;

        const childStepId = child.props.id ?? index;
        const isActive = childStepId === currentStep || index === currentStep;

        if (!isActive) return null;

        return React.cloneElement(child, {
          stepIndex: index,
          isActive,
        });
      })}
    </>
  );
}

export function Step({ children }) {
  return <>{children}</>;
}

Steps.propTypes = {
  currentStep: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  children: PropTypes.node,
};

Steps.defaultProps = {
  currentStep: 0,
  children: null,
};

Step.propTypes = {
  children: PropTypes.node,
};

Step.defaultProps = {
  children: null,
};
